import { __extends, __decorate, __metadata, __param } from 'tslib';
import { Input, Component, forwardRef, ViewEncapsulation, Self, Optional, ChangeDetectorRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { UkFormControlsModule } from '@uikit/components/uk-form-controls';
import { UIKitIconsModule } from '@uikit/components/uk-icons';
import { NgControl } from '@angular/forms';
import { format, parse, isValid, addMonths, isBefore, isAfter, startOfMonth, getDaysInMonth, addDays, isSameDay, isWithinRange, isSameYear, isSameMonth, subMonths, subYears, addYears } from 'date-fns';
import { UkBaseFormControl } from '@uikit/components/common';

var UKCalendarDate = /** @class */ (function () {
    function UKCalendarDate(_date, _label) {
        this.mDate = _date;
        this.label = _label;
        this.disabled = false;
        this.today = this.isToday(_date);
        this.isWeekend = (_date.getDay() === 0 || _date.getDay() === 6);
    }
    UKCalendarDate.prototype.isToday = function (date) {
        var today = new Date().toLocaleDateString();
        return (today === date.toLocaleDateString());
        // return (today.getDate() === date.getDate() && ((today.getMonth() === date.getMonth())) && (today.getFullYear() === date.getFullYear()) );
    };
    return UKCalendarDate;
}());

var UKMonth = /** @class */ (function () {
    function UKMonth(_value, _name, _year) {
        this.isDisabled = false;
        this.value = _value;
        this.name = _name;
        this.year = _year;
        this.mDate = new Date(_year, _value, 1);
    }
    return UKMonth;
}());

var UKYear = /** @class */ (function () {
    function UKYear(_value, _months) {
        this.value = _value;
        this.months = _months;
    }
    return UKYear;
}());

var UKCalendarType;
(function (UKCalendarType) {
    UKCalendarType["SINGLE"] = "single";
    UKCalendarType["LONG"] = "long";
    UKCalendarType["SHORT"] = "short";
})(UKCalendarType || (UKCalendarType = {}));

var UkBaseDatePicker = /** @class */ (function (_super) {
    __extends(UkBaseDatePicker, _super);
    function UkBaseDatePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UkBaseDatePicker;
}(UkBaseFormControl));
var UKDatePickerComponent = /** @class */ (function (_super) {
    __extends(UKDatePickerComponent, _super);
    function UKDatePickerComponent(ngControl, cdRef) {
        var _this = _super.call(this, ngControl, 'date-picker') || this;
        _this.ngControl = ngControl;
        _this.cdRef = cdRef;
        _this.yearDate = new Date();
        _this.nMonths = 1;
        _this.isRange = false;
        _this.isSelectingRange = false;
        _this.currentDate = new Date();
        _this.initialDateText = '';
        _this.endDateText = '';
        // TODO: made them configurable
        _this.monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        _this.dayNames = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
        _this.charsLimit = 3;
        _this.disableWeekEnds = false;
        _this.calendarType = UKCalendarType.SINGLE;
        _this._monthClickable = false;
        _this._isCalendarOpen = false;
        return _this;
    }
    UKDatePickerComponent_1 = UKDatePickerComponent;
    Object.defineProperty(UKDatePickerComponent.prototype, "months", {
        get: function () { return this._months; },
        set: function (value) { this._months = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UKDatePickerComponent.prototype, "monthSelection", {
        get: function () { return this._monthSelection; },
        set: function (value) { this._monthSelection = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UKDatePickerComponent.prototype, "years", {
        get: function () { return this._years; },
        set: function (value) { this._years = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UKDatePickerComponent.prototype, "monthClickable", {
        get: function () { return this._monthClickable; },
        set: function (value) { this._monthClickable = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UKDatePickerComponent.prototype, "isCalendarOpen", {
        get: function () {
            return this._isCalendarOpen;
        },
        set: function (value) {
            value ? this.openCalendar() : this.closeCalendar();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UKDatePickerComponent.prototype, "selectedDates", {
        get: function () {
            return this._selectedDates;
        },
        set: function (value) {
            if (this.selectedDates !== value) {
                this._selectedDates = value;
                this.isCalendarOpen = false;
                if (this.selectedDates.length > 0) {
                    this.initialDateText = format(this.selectedDates[0], 'MM/DD/YYYY');
                    if (this.isRange) {
                        this.endDateText = format(this.selectedDates[1], 'MM/DD/YYYY');
                    }
                }
                else {
                    this.initialDateText = '';
                    this.endDateText = '';
                }
                this.setNgValue(this.calendarType === UKCalendarType.SINGLE ? this.selectedDates[0] : this.selectedDates);
            }
        },
        enumerable: true,
        configurable: true
    });
    UKDatePickerComponent.prototype.onDateTextChange = function (text, isEnd) {
        if (text.length >= 8) {
            var date = parse(text);
            if (isValid(date)) {
                if (this.createUKDay(date, 0).disabled) ;
                else {
                    this.selectedDates = [date];
                }
            }
        }
        else if (text.length === 0) {
            this.selectedDates = [];
        }
    };
    UKDatePickerComponent.prototype.generateCalendar = function () {
        this.months = [];
        var _month;
        var _date;
        for (var i = 0; i < this.nMonths; i++) {
            _date = addMonths(this.currentDate, i);
            _month = new UKMonth(_date.getMonth(), this.monthNames[_date.getMonth()], _date.getFullYear());
            _month.weeks = this.generateWeeks(_date);
            this.months.push(_month);
        }
    };
    UKDatePickerComponent.prototype.generateWeeks = function (workingdate) {
        var _dates = this.fillDays(workingdate);
        var _weeks = [];
        while (_dates.length > 0) {
            _weeks.push(_dates.splice(0, 7));
        }
        return _weeks;
    };
    UKDatePickerComponent.prototype.generateYears = function () {
        var cYear = this.yearDate.getFullYear();
        var _year;
        var _years = [];
        for (var i = 0; i < 3; i++) {
            _year = cYear + i;
            _years.push(new UKYear(_year, this.generateMonths(_year)));
        }
        this.years = _years;
    };
    UKDatePickerComponent.prototype.generateMonths = function (_year) {
        var _months = [];
        var _month;
        for (var i = 0; i < this.monthNames.length; i++) {
            _month = new UKMonth(i, this.monthNames[i], _year);
            if (this.minDate) {
                _month.isDisabled = isBefore(this.minDate, 'month');
            }
            if (this.maxDate && !_month.isDisabled) {
                _month.isDisabled = isAfter(this.maxDate, 'month');
            }
            _months.push(_month);
        }
        return _months;
    };
    // Gets all days in current month
    UKDatePickerComponent.prototype.fillDays = function (currentMoment) {
        var firstOfMonth = startOfMonth(currentMoment);
        var startDayOfWeekM = firstOfMonth.getDay();
        var daysInMonth = getDaysInMonth(currentMoment);
        var _days = [];
        var idx = -startDayOfWeekM;
        for (idx; idx < daysInMonth; idx++) {
            _days.push(this.createUKDay(addDays(firstOfMonth, idx), idx));
        }
        return _days;
    };
    UKDatePickerComponent.prototype.createUKDay = function (date, idx) {
        var _cd = new UKCalendarDate(date, date.getDate());
        _cd.isCurrentMonth = idx >= 0;
        _cd.disabled = this.shouldDisableDay(_cd) || idx < 0;
        return _cd;
    };
    // dynamic properties
    UKDatePickerComponent.prototype.isDaySelected = function (date) {
        var _rValue = false;
        if (!date.disabled && this.selectedDates.length > 0) {
            _rValue = (!this.isRange || this.selectedDates.length === 1) ?
                isSameDay(date.mDate, this.selectedDates[0]) :
                isWithinRange(date.mDate.toString(), date.mDate.toString(), this.selectedDates[1]);
        }
        return _rValue;
    };
    UKDatePickerComponent.prototype.isMonthSelected = function (month) {
        return isSameDay(this.currentDate, month.mDate);
    };
    UKDatePickerComponent.prototype.shouldDisableDay = function (date) {
        var _rValue = false;
        // Validate if should disable all days before minDate
        if (this.minDate) {
            _rValue = isAfter(this.minDate, date.mDate.toString());
        }
        // Validate if should disable all days after maxDate
        if (this.maxDate && !_rValue) {
            _rValue = isBefore(this.maxDate, date.mDate.toString());
        }
        // Validate if should disable weekends
        if (this.disableWeekEnds && !_rValue) {
            _rValue = date.isWeekend;
        }
        return _rValue;
    };
    // Events
    UKDatePickerComponent.prototype.openCalendar = function () {
        if (!this.disabled) {
            this._isCalendarOpen = true;
            this.cdRef.detectChanges();
        }
    };
    UKDatePickerComponent.prototype.closeCalendar = function () {
        this._isCalendarOpen = false;
        this.cdRef.detectChanges();
    };
    UKDatePickerComponent.prototype.openMonthSelection = function () {
        this.yearDate = this.currentDate;
        this.monthSelection = true;
        this.generateYears();
        this.cdRef.detectChanges();
    };
    UKDatePickerComponent.prototype.onDayHover = function (day) {
        if (this.calendarType === 'short' && this.isSelectingRange && this.selectedDates) {
            if (this.selectedDates.length > 0) {
                if (isAfter(day.mDate.toString(), this.selectedDates[0])) {
                    this.selectedDates = [this.selectedDates[0], day.mDate];
                }
            }
        }
    };
    UKDatePickerComponent.prototype.onMonthSelected = function (month) {
        this.currentDate = month.mDate;
        this.generateCalendar();
        this.monthSelection = false;
        this.cdRef.detectChanges();
    };
    UKDatePickerComponent.prototype.onDaySelected = function (day) {
        if (!this.isRange) {
            this.selectedDates = [day.mDate];
            this.currentDate = day.mDate;
        }
        else {
            if (this.selectedDates.length > 0 && this.isSelectingRange) {
                //Converted function
                if (isAfter(this.selectedDates[0], 'day')) {
                    this.selectedDates = [this.selectedDates[0], day.mDate];
                    this.isSelectingRange = false;
                }
            }
            else {
                this.selectedDates = [day.mDate];
                this.isSelectingRange = true;
            }
        }
        this.cdRef.detectChanges();
    };
    // Arrows Navigation
    UKDatePickerComponent.prototype.allowPrevNav = function (granularity) {
        var _rValue = true;
        if (this.minDate) {
            if (granularity === 'year') {
                _rValue = !((isSameYear(this.yearDate, this.minDate)) && (isBefore(this.yearDate, this.minDate)));
            }
            else if (granularity === 'month') {
                _rValue = !(isSameMonth(this.currentDate, this.minDate) && (isAfter(this.currentDate, this.minDate)));
            }
        }
        return _rValue;
    };
    UKDatePickerComponent.prototype.allowNextNav = function (granularity) {
        var _rValue = true;
        if (this.maxDate) {
            if (granularity === 'year') {
                _rValue = !((addMonths(this.yearDate, 3)) && (isSameYear(this.yearDate, this.maxDate)));
            }
            else if (granularity === 'month') {
                _rValue = !(isSameMonth(this.currentDate, this.maxDate)) || (isBefore(this.currentDate.getFullYear(), this.maxDate.getFullYear()));
            }
        }
        return _rValue;
    };
    UKDatePickerComponent.prototype.prevMonth = function () {
        this.currentDate = subMonths(this.currentDate.toString(), 1);
        this.generateCalendar();
        this.cdRef.detectChanges();
    };
    UKDatePickerComponent.prototype.nextMonth = function () {
        this.currentDate = addMonths(this.currentDate.toString(), 1);
        this.generateCalendar();
        this.cdRef.detectChanges();
    };
    UKDatePickerComponent.prototype.prevYear = function () {
        this.yearDate = subYears(this.yearDate.toString(), 3);
        this.generateYears();
        this.cdRef.detectChanges();
    };
    UKDatePickerComponent.prototype.nextYear = function () {
        this.yearDate = addYears(this.yearDate.toString(), 3);
        this.generateYears();
        this.cdRef.detectChanges();
    };
    // ===> Angular LifeCycle Hooks <===
    UKDatePickerComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.maxDate && this.currentDate > this.maxDate) {
            this.currentDate = this.maxDate;
        }
        this.generateCalendar();
    };
    var UKDatePickerComponent_1;
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UKDatePickerComponent.prototype, "disableWeekEnds", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UKDatePickerComponent.prototype, "calendarType", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], UKDatePickerComponent.prototype, "holidays", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Date)
    ], UKDatePickerComponent.prototype, "minDate", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Date)
    ], UKDatePickerComponent.prototype, "maxDate", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], UKDatePickerComponent.prototype, "monthClickable", null);
    UKDatePickerComponent = UKDatePickerComponent_1 = __decorate([
        Component({
            selector: 'uk-date-picker',
            host: { class: 'uk-date-picker' },
            providers: [{
                    provide: UkBaseFormControl,
                    useExisting: forwardRef(function () { return UKDatePickerComponent_1; })
                }],
            template: "<!--Placeholder should be configarable-->\r\n<div class=\"uk-form-control\" cdk-overlay-origin #origin=\"cdkOverlayOrigin\" #trigger>\r\n    <div class=\"uk-form-control__value\">\r\n      <input ukDate placeholder=\"MM/DD/YY\"\r\n      [id]=\"id\" [disabled]=\"disabled\" ([focused])=\"focused\" \r\n      [value]=\"initialDateText\" (valueChange)=\"onDateTextChange($event)\"/>\r\n    </div>\r\n    <div class=\"uk-form-control__addon\">\r\n      <button class=\"uk-btn none uk-date-picker__icon\"\r\n        ukIcon=\"datepicker\" (click)=\"openCalendar()\">\r\n      </button>\r\n    </div>\r\n  </div>\r\n  \r\n  <ng-template \r\n    cdkConnectedOverlay\r\n    cdkConnectedOverlayLockPosition\r\n    [cdkConnectedOverlayOrigin]=\"origin\"\r\n    [cdkConnectedOverlayOpen]=\"isCalendarOpen\"\r\n    cdkConnectedOverlayHasBackdrop\r\n    cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\r\n    (backdropClick)=\"closeCalendar()\"\r\n    (detach)=\"closeCalendar()\">\r\n    \r\n    <div class=\"uk-calendar {{calendarType}}\">\r\n      <!-- Day Seleccion -->\r\n      <div *ngIf=\"!monthSelection\" class=\"frow\">\r\n        <div *ngFor=\"let month of months; let i = index\" class=\"fcol uk-calendar-month-group\">\r\n          <div class=\"frow between uk-calendar-nav-bar\">\r\n            <div class=\"fcol\">\r\n              <!-- Previous Month -->\r\n              <button ukIcon=\"arrow-chevron\" ukIconRotation=\"180\"\r\n                type=\"button\" class=\"uk-btn uk-calendar-nav prev none\"\r\n                *ngIf=\"allowPrevNav('month') && i === 0\"\r\n                (click)=\"prevMonth()\">\r\n              </button>\r\n            </div>\r\n            <!-- Title -->\r\n            <div class=\"fcol text-center\">\r\n              <button type=\"button\" class=\"uk-btn none\" (click)=\"openMonthSelection()\" *ngIf=\"monthClickable\">\r\n                {{ month.name }} {{ month.year }}\r\n              </button>\r\n              <span *ngIf=\"!monthClickable\">\r\n                {{ month.name }} {{ month.year }}\r\n              </span>\r\n            </div>\r\n            <div class=\"fcol text-right\">\r\n              <!-- Next Month -->\r\n              <button ukIcon=\"arrow-chevron\"\r\n                type=\"button\" class=\"uk-btn uk-calendar-nav next none\" \r\n                *ngIf=\"allowNextNav('month') && i === months.length - 1\"\r\n                (click)=\"nextMonth()\" >\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <!--  -->\r\n          <table>\r\n            <thead>\r\n              <tr class=\"uk-week-days\">\r\n                <td class=\"uk-week-day text-center uk-week-name\" *ngFor=\"let weekDay of dayNames\">\r\n                  {{weekDay | slice:0:charsLimit}}\r\n                </td>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr class=\"uk-week-days\" *ngFor=\"let week of month.weeks\">\r\n                <td class=\"uk-week-day text-center\" *ngFor=\"let d of week\" [ngClass]=\"{'active': isDaySelected(d)}\" >\r\n                  <button type=\"button\" class=\"uk-calendar-selectable-item uk-btn none\" *ngIf=\"d.isCurrentMonth\" \r\n                    [disabled]=\"d.disabled\"\r\n                    [ngClass]=\"{'today': d.today, 'active': isDaySelected(d)}\" \r\n                    (click)=\"onDaySelected(d)\"\r\n                    (mouseover)=\"onDayHover(d)\">\r\n                      {{d.label}}\r\n                  </button>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    \r\n      <!-- Months -->\r\n      <table *ngIf=\"monthSelection\" class=\"uk-calendar-month\">\r\n        <thead>\r\n          <tr>\r\n            <td colspan=\"7\" class=\"text-center\">\r\n              <button ukIcon=\"arrow-chevron\" ukIconRotation=\"270\" \r\n                *ngIf=\"allowPrevNav('year')\" type=\"button\" class=\"uk-btn none\"\r\n                (click)=\"prevYear()\">\r\n              </button>\r\n            </td>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <ng-template ngFor [ngForOf]=\"years\" let-year>\r\n            <tr class=\"uk-week-days\">\r\n              <td rowspan=\"2\" class=\"uk-year-label\">\r\n                {{year.value}}\r\n              </td>\r\n              <ng-template ngFor [ngForOf]=\"year.months\" let-month let-i=\"index\">\r\n                <td *ngIf=\"i < 6\" class=\"uk-week-day text-center\">\r\n                  <button type=\"button\" class=\"uk-calendar-selectable-item uk-btn none\" \r\n                    [ngClass]=\"{'active': isMonthSelected(month)}\"\r\n                    [disabled]=\"month.isDisabled\"\r\n                    (click)=\"onMonthSelected(month)\">\r\n                    {{month.name | slice:0:charsLimit}}\r\n                  </button>\r\n                </td>\r\n              </ng-template>\r\n            </tr>\r\n            <tr class=\"uk-week-days\">\r\n              <ng-template ngFor [ngForOf]=\"year.months\" let-month let-i=\"index\">\r\n                <td *ngIf=\"i >= 6\" class=\"uk-week-day text-center\">\r\n                  <button type=\"button\" class=\"uk-calendar-selectable-item uk-btn none\" \r\n                    [ngClass]=\"{'active': isMonthSelected(month)}\"\r\n                    [disabled]=\"month.isDisabled\"\r\n                    (click)=\"onMonthSelected(month)\">\r\n                    {{month.name | slice:0:charsLimit}}\r\n                  </button>\r\n                </td>\r\n              </ng-template>\r\n            </tr>\r\n          </ng-template>\r\n        </tbody>\r\n        <tfoot>\r\n          <tr>\r\n            <td colspan=\"7\" class=\"text-center\">\r\n              <button ukIcon=\"arrow-chevron\" ukIconRotation=\"90\" \r\n                *ngIf=\"allowNextNav('year')\" type=\"button\" class=\"uk-btn none\" \r\n                (click)=\"nextYear()\">\r\n              </button>\r\n            </td>\r\n          </tr>\r\n        </tfoot>\r\n      </table>\r\n    </div>\r\n  </ng-template>",
            encapsulation: ViewEncapsulation.None
        }),
        __param(0, Self()), __param(0, Optional()),
        __metadata("design:paramtypes", [NgControl, ChangeDetectorRef])
    ], UKDatePickerComponent);
    return UKDatePickerComponent;
}(UkBaseDatePicker));

var ukDayNames = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
var UKDaySelectionComponent = /** @class */ (function () {
    function UKDaySelectionComponent() {
        this.dayNames = ukDayNames;
        this.charsLimit = 3;
        this.monthClickable = false;
    }
    UKDaySelectionComponent.prototype.onDaySelected = function (day) { };
    UKDaySelectionComponent.prototype.onDayHover = function (day) { };
    UKDaySelectionComponent.prototype.prevMonth = function () { };
    UKDaySelectionComponent.prototype.nextMonth = function () { };
    UKDaySelectionComponent.prototype.isDaySelected = function (value) { return true; };
    // Arrows Navigation
    UKDaySelectionComponent.prototype.allowPrevNav = function (granularity) {
        return false;
    };
    UKDaySelectionComponent.prototype.allowNextNav = function (granularity) {
        return false;
    };
    UKDaySelectionComponent.prototype.openMonthSelection = function () { };
    __decorate([
        Input(),
        __metadata("design:type", UKMonth)
    ], UKDaySelectionComponent.prototype, "month", void 0);
    UKDaySelectionComponent = __decorate([
        Component({
            selector: 'uk-day-selection',
            template: "<div class=\"frow uk-calendar-nav-bar\">\r\n  <div class=\"fcol\">\r\n    <!-- Previous Month -->\r\n    <button ukIcon=\"arrow-chevron\" ukIconRotation=\"180\"\r\n      type=\"button\" class=\"uk-btn uk-calendar-nav prev none\"\r\n      *ngIf=\"allowPrevNav('month')\"\r\n      (click)=\"prevMonth()\">\r\n    </button>\r\n  </div>\r\n  <!-- Title -->\r\n  <div class=\"fcol text-center\">\r\n    <button type=\"button\" class=\"uk-btn none\" (click)=\"openMonthSelection()\" *ngIf=\"monthClickable\">\r\n      {{ month.name }} {{ month.year }}\r\n    </button>\r\n    <span *ngIf=\"!monthClickable\">\r\n      {{ month.name }} {{ month.year }}\r\n    </span>\r\n  </div>\r\n  <div class=\"fcol text-right\">\r\n    <!-- Next Month -->\r\n    <!-- && i === months.length - 1-->\r\n    <button ukIcon=\"arrow-chevron\"\r\n      type=\"button\" class=\"uk-btn uk-calendar-nav next none\" \r\n      *ngIf=\"allowNextNav('month')\"\r\n      (click)=\"nextMonth()\" >\r\n    </button>\r\n  </div>\r\n</div>\r\n<!-- Weeks Display -->\r\n<table>\r\n  <thead>\r\n    <tr class=\"uk-week-days\">\r\n      <td class=\"uk-week-day text-center uk-week-name\" *ngFor=\"let weekDay of dayNames\">\r\n        {{weekDay | slice:0:charsLimit}}\r\n      </td>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n    <tr class=\"uk-week-days\" *ngFor=\"let week of month.weeks\">\r\n      <td class=\"uk-week-day text-center\" *ngFor=\"let d of week\" [ngClass]=\"{'active': isDaySelected(d)}\" >\r\n        <button type=\"button\" class=\"uk-calendar-selectable-item uk-btn none\" *ngIf=\"d.isCurrentMonth\" \r\n          [disabled]=\"d.disabled\"\r\n          [ngClass]=\"{'today': d.today, 'active': isDaySelected(d)}\" \r\n          (click)=\"onDaySelected(d)\"\r\n          (mouseover)=\"onDayHover(d)\">\r\n            {{d.label}}\r\n        </button>\r\n      </td>\r\n    </tr>\r\n  </tbody>\r\n</table>",
            encapsulation: ViewEncapsulation.None
        })
    ], UKDaySelectionComponent);
    return UKDaySelectionComponent;
}());

var UIKitDatePickerModule = /** @class */ (function () {
    function UIKitDatePickerModule() {
    }
    UIKitDatePickerModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                OverlayModule,
                PortalModule,
                // UI Kit
                UIKitIconsModule,
                UkFormControlsModule
            ],
            declarations: [
                UKDatePickerComponent,
                UKDaySelectionComponent
            ],
            exports: [UKDatePickerComponent]
        })
    ], UIKitDatePickerModule);
    return UIKitDatePickerModule;
}());

export { UIKitDatePickerModule, UkBaseDatePicker as ɵa, UKDatePickerComponent as ɵb, UKDaySelectionComponent as ɵc };
//# sourceMappingURL=uikit-components-uk-date-picker.js.map
